import { Dialog } from "@mui/material";
import { useState } from "react";
import { IDataSetores } from "../../types/api/estoque/pesquisar-setores";
import DialogContentSelectGeneric from "./DialogsContents/DialogContentGeneric";
import MultipleChipsField from "../BaseInputs/MultipleChipsField";

export default function SelectSetor({
  value,
  onChange,
  required = false,
  error = false, 
  multiple = true,
}: SelectSetorProps) {
  const [openModal, setOpenModal] = useState(false);

  const handleClose = () => setOpenModal(false);

  return (
    <>
      <MultipleChipsField
        value={value}
        label="Setores"
        required={required}
        formatChipLabel={(item) => `${item.id} - ${item.nome}`}
        onClick={() => setOpenModal(true)}
        error={!!error}
        helperText={error ? "Campo obrigatório" : ""}
      />

      {openModal && (
        <Dialog fullWidth maxWidth="sm" open={openModal} onClose={handleClose}>
          <DialogContentSelectGeneric
            {...{ handleClose }}
            multiple={multiple}
            title="Selecionar setor"
            queryPath="estoque/pesquisar-setores"
            getItemKey={(item) => item?.id ?? 0}
            getItemLabel={(item) => (item ? `${item.id} - ${item.nome}` : "")}
            defaultValue={value ?? []}
            onChange={(value) => {
              onChange(value as IDataSetores[]);
              handleClose();
            }}
          />
        </Dialog>
      )}
    </>
  );
}

interface SelectSetorProps {
  value: IDataSetores[] | null;
  onChange: (arg: IDataSetores[] | null) => void;
  required?: boolean;
  error?: boolean;
  multiple?: boolean;
}
